export default {
  "about": "Sobre",
  "about_title": "Sobre Nós",
  "access_secret": "Segredo de Acesso",
  "access_token": "Token de Acesso",
  "accessibility_animations": "Animações",
  "accessibility_contrast": "Contraste",
  "accessibility_font_size": "Tamanho da Fonte",
  "accessibility_title": "Acessibilidade",
  "actions": "Ações",
  "active": "Ativo",
  "active_ads": "Anúncios Ativos",
  "active_campaigns": "Campanhas Ativas",
  "ad_code_placeholder": "<script>...</script> ou código do slot AdSense",
  "ad_format": "Formato do Anúncio",
  "ad_formats": "Formatos de anuncios",
  "ad_management": "Gestao de anuncios",
  "ad_position_settings": "Configurações de Posicionamento de Anúncios",
  "ad_price_list": "Lista de Preços de Anúncios",
  "ad_pricing_formats_campaigns": "Preços, formatos, campanhas e monitoramento",
  "add": "Adicionar",
  "add_api_keys": "Adicionar chaves API na aba Configurar",
  "address": "Endereço",
  "admin": "Admin",
  "adminPanel": "Painel de Administração",
  "admin_ab_testing_title": "Teste A/B",
  "admin_accent": "Destaque",
  "admin_accent_color": "Cor de Destaque",
  "admin_action": "Ação",
  "admin_activate": "Ativar",
  "admin_active_feeds": "Feeds Ativos",
  "admin_active_label": "ATIVO",
  "admin_active_now": "Ativo Agora",
  "admin_active_subscribers": "Assinantes Ativos",
  "admin_ad_performance": "Desempenho de Anúncios",
  "admin_add_feed": "Adicionar Feed",
  "admin_add_tag": "Adicionar Tag",
  "admin_admins": "Administradores",
  "admin_advertisements": "Anúncios",
  "admin_advertiser_email": "Email do Anunciante",
  "admin_advertiser_name": "Nome do Anunciante",
  "admin_affiliate_links": "Links de Afiliados",
  "admin_ai_content_title": "Processamento de Conteúdo de IA",
  "admin_ai_prompt_settings": "Configurações de Prompt & Modelo de IA",
  "admin_analytics_title": "Análise",
  "admin_api_latency": "Latência API",
  "admin_api_server": "Servidor API",
  "admin_article_actions": "Ações",
  "admin_article_category": "Categoria",
  "admin_article_published": "Publicado",
  "admin_article_selector": "Seletor de artigo (CSS, por exemplo, artigo.noticia)",
  "admin_article_views": "Visualizações",
  "admin_articles_count": "Artigos",
  "admin_articles_title": "Artigos",
  "admin_author_change_failed": "Falha na alteração de autor.",
  "admin_authors_title": "Autores",
  "admin_auto": "AUTO",
  "admin_auto_save_draft": "Auto-salvar como rascunho",
  "admin_avg_seo_score": "Pontuação Média de SEO",
  "admin_bio": "Bio",
  "admin_blog_manage": "Gerenciar postagens do blog com editor de conteúdo enriquecido",
  "admin_blog_title": "Blog",
  "admin_brand_theme": "Marca & Tema",
  "admin_branding_desc": "Personalizar aparência do site (Apenas Administrador do Sistema)",
  "admin_branding_title": "Módulo de Rebranding",
  "admin_breaking_ticker": "Ticker de Últimas Notícias",
  "admin_browser": "Navegador",
  "admin_browsers": "Navegadores",
  "admin_bug_reports": "Relatórios de Erros",
  "admin_bulk_delete_failed": "Falha na exclusão em massa.",
  "admin_bulk_operations": "Operações em Massa",
  "admin_categories_grid": "Grade de Categorias",
  "admin_choose_gallery": "Escolher da Galeria",
  "admin_churn_prediction": "Previsão de Cancelamento",
  "admin_classic_portal": "Portal de Notícias Clássico",
  "admin_classifieds": "Classificados",
  "admin_clear_log": "Limpar Log",
  "admin_click_button": "Clique no botão",
  "admin_collection_stats": "Estatísticas de Coleta",
  "admin_color_scheme": "Esquema de Cores",
  "admin_columnist": "Colunista",
  "admin_comments": "Comentários",
  "admin_competitor_monitoring": "Monitoramento de Concorrentes",
  "admin_confirm_action": "Você tem certeza?",
  "admin_content_calendar_title": "Calendário de Conteúdo",
  "admin_content_filter": "Termos de Filtro de Conteúdo",
  "admin_content_stats": "Estatísticas de Conteúdo",
  "admin_contributor": "Colaborador",
  "admin_coordinates": "Coordenadas",
  "admin_copy_ip": "Copiar endereço IP",
  "admin_copy_text": "Copiar",
  "admin_core_services": "Serviços Principais",
  "admin_countries": "Países",
  "admin_cpc": "CPC (EUR)",
  "admin_crawl_now": "Rastrear agora",
  "admin_create_author": "Criar Autor",
  "admin_create_manage_promo": "Criar e gerenciar códigos promocionais",
  "admin_create_voucher": "Criar Cupom",
  "admin_custom_meta": "Meta Personalizada",
  "admin_dashboard_title": "Painel de Controle",
  "admin_database": "Base de Dados",
  "admin_db_backup": "Backup de Banco de Dados",
  "admin_db_latency": "Latência do BD",
  "admin_db_name": "Nome do banco de dados",
  "admin_db_size": "Tamanho do BD",
  "admin_default": "PADRÃO",
  "admin_default_language": "Idioma Padrão",
  "admin_device": "Dispositivo",
  "admin_devices": "Dispositivos",
  "admin_discount": "Desconto",
  "admin_disk_usage": "Uso de Disco",
  "admin_docs_api_ref": "Referência da API",
  "admin_docs_download_pdf": "Baixar PDF",
  "admin_docs_faq": "FAQ",
  "admin_docs_getting_started": "Introdução",
  "admin_docs_implemented": "Implementado",
  "admin_docs_no_pages": "Ainda não há páginas de documentação",
  "admin_docs_order": "Ordem",
  "admin_docs_title": "Documentação",
  "admin_doktor_earnings": "Ganhos do Doktor",
  "admin_draft_articles": "Artigos em Rascunho",
  "admin_dynamic_pricing": "Preço Dinâmico",
  "admin_edit_in_cms": "Editar no CMS",
  "admin_editor_role": "Editor",
  "admin_export_csv": "Exportar CSV",
  "admin_favicon": "Favicon",
  "admin_feed_crawler": "Rastreador de Feed",
  "admin_feed_name": "Nome do Feed",
  "admin_feed_url": "URL do Feed",
  "admin_feeds_title": "Feeds RSS",
  "admin_file": "Arquivo",
  "admin_fixed_amount": "Valor Fixo",
  "admin_frozen": "Congelado",
  "admin_full_name": "Nome completo",
  "admin_general": "Geral",
  "admin_google_search_console": "Google Search Console",
  "admin_grade": "Classificação",
  "admin_health_title": "Verificação de Saúde",
  "admin_high_leads": "Leads de Alto Valor",
  "admin_import_title": "Plataforma de Importação Croatia Times",
  "admin_index_now": "IndexNow",
  "admin_integrations": "Integrações",
  "admin_job_postings": "Anúncios de Emprego",
  "admin_joined": "Entrou",
  "admin_keywords": "Palavras-chave",
  "admin_landing_title": "Páginas de Entrada",
  "admin_last_submissions": "Últimas Submissões",
  "admin_live_analytics": "Análises em Tempo Real",
  "admin_live_analytics_title": "Análise ao Vivo",
  "admin_llm_model": "Modelo LLM",
  "admin_manage_feeds": "Gerenciar Feeds",
  "admin_mass_management": "Gerenciamento em massa de artigos",
  "admin_max_articles": "Máximo de artigos",
  "admin_media_storage": "Armazenamento de Mídia",
  "admin_memory": "Memória",
  "admin_menu_manager": "Gerenciador de Menu",
  "admin_meta_description": "Descrição meta",
  "admin_monetization_title": "Painel de Monetização",
  "admin_mysql_db": "Banco de dados MySQL",
  "admin_mysql_host": "Host MySQL",
  "admin_nav_ab_testing": "Testes A/B",
  "admin_nav_ads": "Gestão de Anúncios",
  "admin_nav_ads_report": "Relatório de Anúncios",
  "admin_nav_adsense": "Configurações do AdSense",
  "admin_nav_advanced_analytics": "Análises Avançadas",
  "admin_nav_affiliates": "Links de Afiliados",
  "admin_nav_ai_content": "Processamento de Conteúdo de IA",
  "admin_nav_amp": "AMP & Google Discover",
  "admin_nav_analytics": "Análises",
  "admin_nav_analytics_ai": "Análises e IA",
  "admin_nav_articles": "Artigos",
  "admin_nav_audit_log": "Log de Auditoria",
  "admin_nav_authors": "Autores",
  "admin_nav_blog": "Blog",
  "admin_nav_branding": "Rebranding",
  "admin_nav_breaking_news": "Notícias de Última Hora / Flash",
  "admin_nav_bulk_operations": "Operações em Massa",
  "admin_nav_categories": "Categorias",
  "admin_nav_chat_sessions": "Sessões de Chat",
  "admin_nav_churn_prediction": "Previsão de Churn",
  "admin_nav_classifieds": "Classificados",
  "admin_nav_comments": "Comentários",
  "admin_nav_competitor_monitoring": "Monitoramento de Concorrentes",
  "admin_nav_content": "Conteúdo",
  "admin_nav_content_calendar": "Calendário de Conteúdo",
  "admin_nav_county_map": "Mapa do Condado",
  "admin_nav_crypto": "Widget de Cripto",
  "admin_nav_dashboard": "Painel de Controle",
  "admin_nav_db_backup": "Banco de Dados",
  "admin_nav_docs": "Documentação",
  "admin_nav_doktor_earnings": "Rendimentos do Doktor",
  "admin_nav_duplicate_detection": "Detecção de Duplicações",
  "admin_nav_editorial": "Editorial",
  "admin_nav_editorial_workflow": "Fluxo de Trabalho Editorial",
  "admin_nav_email_campaigns": "Campanhas de Email",
  "admin_nav_feeds": "Feeds RSS",
  "admin_nav_finance": "Finanças",
  "admin_nav_health": "Saúde do Sistema",
  "admin_nav_heatmaps": "Mapa de Calor de Leitura",
  "admin_nav_import": "Importar",
  "admin_nav_invoices": "Faturas",
  "admin_nav_job_ads": "Anúncios de Emprego",
  "admin_nav_landing_pages": "Páginas de Destino",
  "admin_nav_live_analytics": "Análises em Tempo Real",
  "admin_nav_management": "Gestão",
  "admin_nav_marketing": "Marketing",
  "admin_nav_media": "Mídia",
  "admin_nav_menu_manager": "Gerenciador de Menu",
  "admin_nav_micropayments": "Micropagamentos",
  "admin_nav_monetization": "Monetização",
  "admin_nav_newsletter": "Newsletter",
  "admin_nav_newsletter_digest": "Resumo do Newsletter",
  "admin_nav_pages": "Páginas",
  "admin_nav_payments": "Pagamentos",
  "admin_nav_performance_forecast": "Previsão de Desempenho",
  "admin_nav_photo_verification": "Verificação de Fotos",
  "admin_nav_portal_toggle": "Gestão do Portal",
  "admin_nav_portals": "Portais",
  "admin_nav_pricing": "Preços",
  "admin_nav_promo_codes": "Códigos Promocionais",
  "admin_nav_push_notifications": "Notificações Push",
  "admin_nav_quizzes": "Questionários",
  "admin_nav_recommendations": "Recomendações de Conteúdo",
  "admin_nav_reports": "Relatórios de Conteúdo",
  "admin_nav_sanitization": "Sanitização de Conteúdo",
  "admin_nav_scheduler": "Programador de Conteúdo",
  "admin_nav_security": "Segurança",
  "admin_nav_seo_dashboard": "Painel de SEO",
  "admin_nav_seo_distribution": "SEO & Distribuição",
  "admin_nav_series": "Série de Artigos",
  "admin_nav_settings": "Configurações",
  "admin_nav_social": "Mídia Social",
  "admin_nav_social_scheduler": "Agendador Social",
  "admin_nav_sponsored": "Patrocinado",
  "admin_nav_sponsored_marketplace": "Mercado de Patrocínios",
  "admin_nav_subscriptions": "Assinaturas",
  "admin_nav_surveys": "Pesquisas",
  "admin_nav_syndication": "API de Sindicação",
  "admin_nav_system": "Sistema",
  "admin_nav_tips": "Gorjetas / Doações",
  "admin_nav_translations": "Traduções",
  "admin_nav_ugc_review": "Conteúdo dos Cidadãos",
  "admin_nav_users": "Usuários",
  "admin_nav_users_subscriptions": "Usuários e Assinaturas",
  "admin_nav_versioning": "Histórico de Versões",
  "admin_nav_vibeposao": "Portal Times Posao",
  "admin_nav_vouchers": "Vouchers / Descontos",
  "admin_nav_widgets": "Widgets / Catálogos",
  "admin_new_author_name": "Novo nome do autor...",
  "admin_new_post": "Nova Postagem",
  "admin_no_data": "Nenhum dado disponível",
  "admin_no_icon": "Sem ícone",
  "admin_no_logo": "Sem logotipo",
  "admin_no_pending_reports": "Sem relatórios pendentes",
  "admin_no_published_articles": "Nenhum artigo publicado encontrado",
  "admin_password_field": "Senha",
  "admin_performance_forecast": "Previsão de Desempenho",
  "admin_photo_verification": "Verificação de Foto",
  "admin_plan": "Plano",
  "admin_platform_audit": "Auditoria da Plataforma",
  "admin_portal_toggle": "Gestão de Portal",
  "admin_premium_users": "Usuários Premium",
  "admin_primary": "Primária",
  "admin_published_articles": "Artigos Publicados",
  "admin_published_today": "Publicado Hoje",
  "admin_quick_actions": "Ações Rápidas",
  "admin_recent_articles": "Artigos Recentes",
  "admin_role_change_failed": "Falha ao atualizar função.",
  "admin_search_placeholder": "Pesquisar admin...",
  "admin_secondary": "Secundária",
  "admin_seo_desc": "Otimização de conteúdo, gestão de GSC e sitemap",
  "admin_seo_title": "Painel de SEO",
  "admin_service_requests": "Solicitações de Serviço",
  "admin_set_category": "Definir Categoria",
  "admin_set_featured": "Definir como Destaque",
  "admin_settings_saved": "Configurações salvas",
  "admin_settings_title": "Configurações",
  "admin_short_desc": "Descrição curta",
  "admin_site_identity": "Identidade do Site",
  "admin_site_logo": "Logotipo do Site",
  "admin_site_settings": "Configurações do Site",
  "admin_sponsored_marketplace": "Marketplace Patrocinado",
  "admin_sponsored_title": "Artigos Patrocinados",
  "admin_surveys_title": "Pesquisas",
  "admin_system_status": "Status do Sistema",
  "admin_table_header_actions": "Ações",
  "admin_table_header_date": "Data",
  "admin_table_header_email": "Email",
  "admin_table_header_name": "Nome",
  "admin_table_header_status": "Status",
  "admin_thumbnail_settings_saved": "Configurações de miniatura salvas",
  "admin_top_articles_views": "Principais Artigos por Visualizações",
  "admin_total_articles": "Total de Artigos",
  "admin_total_users": "Total de Usuários",
  "admin_total_views": "Total de Visualizações",
  "admin_ugc_review": "Revisão de UGC",
  "admin_username": "Nome de usuário",
  "admin_users_title": "Usuários",
  "admin_version_history": "Histórico de Versões",
  "admin_view_health_report": "Ver relatório completo de saúde",
  "admin_write_new_article": "Escrever Novo Artigo",
  "adsense_client_id": "ID do Cliente AdSense",
  "adsense_enable_disable": "Ativar/desativar toda a veiculação automática de anúncios",
  "adsense_global_toggle": "Alternância Global AdSense",
  "adsense_script_code": "Código do Script AdSense",
  "adsense_settings": "Configurações de AdSense e Posicionamento de Anúncios",
  "advertise_contact_sales": "Contato de Vendas",
  "advertise_get_started": "Começar",
  "advertise_reach_audience": "Alcance nosso público",
  "advertise_title": "Anuncie Conosco",
  "advertiser": "Anunciante",
  "advertiser_analytics": "Análises do Anunciante",
  "advertiser_email": "Email do Anunciante",
  "advertising": "Publicidade",
  "advertising_cookies": "Cookies de Publicidade",
  "affiliate_title": "Programa de Afiliados",
  "ago": "atrás",
  "ai_image_prompt": "Prompt de Imagem AI",
  "all": "Todos",
  "all_categories": "Todas as Categorias",
  "all_jobs": "Todas as vagas",
  "all_rights": "Todos os direitos reservados",
  "all_status": "Todos os Status",
  "all_types": "Todos os Tipos",
  "alpha": "Alpha",
  "alreadyHaveAccount": "Já tem uma conta?",
  "already_have_account": "Ja tem conta?",
  "analytics": "Análises",
  "analytics_cookies": "Cookies de Análise",
  "api_key": "Chave API",
  "api_secret": "Segredo API",
  "applications": "Candidaturas",
  "apply": "Aplicar",
  "apply_now": "Candidatar-se",
  "approve": "Aprovar",
  "approved": "Aprovado",
  "archive": "Arquivar",
  "archived": "Arquivado",
  "article_content": "Conteúdo do Artigo",
  "article_title": "Título do Artigo...",
  "article_views": "Visualizações",
  "author": "Autor",
  "auto_posting": "Postagem automática e integrações sociais",
  "auto_share_articles": "Compartilhar automaticamente artigos publicados em plataformas conectadas",
  "avg_ctr": "CTR Médio",
  "back": "Voltar",
  "basic": "Básico",
  "be_respectful": "Seja respeitoso e civil com outros usuários e assuntos dos artigos",
  "beta": "Beta",
  "book_ad": "Reservar Anúncio",
  "booking_details": "Detalhes da Reserva",
  "breaking": "URGENTE",
  "bug_description": "Descrição do Bug",
  "business": "Negocios",
  "business_account_id": "ID da Conta Empresarial",
  "buyer": "Comprador",
  "campaign_details": "Detalhes da Campanha",
  "campaigns": "Campanhas",
  "cancel": "Cancelar",
  "caption": "Legenda",
  "categories": "Categorias",
  "category": "Categoria",
  "category_distribution": "Distribuição por Categoria",
  "category_push_subscribers": "Assinantes de Push por Categoria",
  "chatbot_placeholder": "Digite uma mensagem...",
  "chatbot_send": "Enviar",
  "chatbot_title": "Assistente de Chat",
  "choose_plan": "Escolha seu plano",
  "city": "Cidade",
  "classifieds": "Classificados",
  "classifieds_title": "Classificados",
  "clear": "Limpar",
  "click_rate": "Taxa de cliques",
  "click_url": "URL de Clique (destino)",
  "clicks": "Cliques",
  "client_id": "ID do Cliente",
  "client_secret": "Segredo do Cliente",
  "close": "Fechar",
  "code": "Código",
  "commenting_rules": "Regras de Comentários",
  "comments": "Comentarios",
  "companies": "Empresas",
  "company": "Empresa",
  "compose_social_post": "Compor Publicação Social",
  "configure": "Configurar",
  "configure_position": "Configure cada posição com uma imagem de banner personalizada ou código de anúncio",
  "confirm": "Confirmar",
  "confirm_delete": "Tem certeza de que deseja excluir?",
  "confirm_password": "Confirmar senha",
  "congratulations": "Parabéns",
  "contact": "Contato",
  "contact_title": "Contato",
  "contact_us": "Contate-Nos",
  "content": "Conteúdo",
  "cookies": "Cookies",
  "cookies_title": "Política de Cookies",
  "copy": "Copiar",
  "copyright": "Direitos autorais",
  "copyright_notice": "Direitos Autorais",
  "count": "Contagem",
  "country": "País",
  "cpm": "CPM",
  "create": "Criar",
  "create_first_ad": "Crie seu primeiro anúncio",
  "crypto_change_24h": "Mudança 24h",
  "crypto_market_cap": "Valor de Mercado",
  "crypto_price": "Preço",
  "crypto_widget_title": "Cripto",
  "ctr": "CTR",
  "culture": "Cultura",
  "current_plan": "Plano atual",
  "custom_ad_code": "Código de Anúncio Personalizado",
  "custom_banner_url": "URL do Banner Personalizado",
  "custom_range": "Intervalo personalizado",
  "daily_budget": "Orçamento Diário",
  "daily_performance": "Desempenho Diário",
  "dark_mode": "Modo escuro",
  "data_viz_title": "Visualização de Dados",
  "date": "Data",
  "dating_add_video": "Adicione um vídeo curto para que os potenciais parceiros possam conhecê-lo melhor",
  "dating_block": "Bloquear",
  "dating_boosts": "Impulsos",
  "dating_city": "Cidade",
  "dating_next": "Próximo",
  "dating_personality_quiz": "Quiz de Personalidade",
  "dating_quiz_completed": "Quiz de personalidade concluído",
  "dating_users": "Usuários",
  "dating_verify_identity": "Verifique se você é uma pessoa real",
  "dating_voice_message": "Mensagem de Voz",
  "days": "dias",
  "delete": "Excluir",
  "delete_failed": "Falha ao excluir.",
  "deleted_successfully": "Excluído com sucesso",
  "deprecated": "Obsoleto",
  "describe_thumbnail": "Descreva a imagem em miniatura para gerar...",
  "description": "Descrição",
  "deselect_all": "Deselecionar tudo",
  "desktop": "Desktop",
  "details": "Detalhes",
  "dimensions": "Dimensões",
  "disabled": "Desativado",
  "dismiss": "Dispensar",
  "documentation": "Documentação",
  "doktor_add_document": "Adicionar Documento",
  "doktor_biography": "Biografia",
  "doktor_birth_date": "Data de Nascimento",
  "doktor_chat": "Chat",
  "doktor_control_date": "Data de Controle",
  "doktor_date": "Data",
  "doktor_diagnosis": "Diagnóstico",
  "doktor_enter_name_specialization": "Insira o nome e pelo menos uma especialização",
  "doktor_enter_patient_name": "Insira o nome do paciente",
  "doktor_license_number": "Número da Licença",
  "doktor_panel": "Painel do Médico",
  "doktor_patient_name": "Nome do Paciente",
  "doktor_text_min_chars": "O texto deve ter pelo menos 50 caracteres",
  "doktor_waiting_room": "Sala de Espera",
  "dont_have_account": "Nao tem conta?",
  "download": "Baixar",
  "draft": "Rascunho",
  "duplicate": "Duplicar",
  "duration_days": "Duração (dias)",
  "economy": "Economia",
  "edit": "Editar",
  "electronics": "Eletrônicos",
  "email": "Email",
  "email_address": "Endereço de email",
  "email_campaigns": "Campanhas de Email",
  "email_clicks": "Cliques no email",
  "email_content": "Conteúdo do email...",
  "email_opens": "Aberturas de email",
  "email_placeholder": "Seu email",
  "email_subject": "Assunto do Email",
  "employer": "Empregador",
  "enabled": "Ativado",
  "end_date": "Data de Término",
  "enter_advertiser_email": "Digite seu email de anunciante...",
  "enter_email_to_view": "Digite seu email de anunciante acima para ver o desempenho da sua campanha",
  "entertainment": "Entretenimento",
  "error": "Erro",
  "error_deleting": "Erro ao eliminar",
  "error_generating_digest": "Erro ao gerar digest",
  "error_loading": "Erro ao carregar",
  "error_saving": "Erro ao salvar",
  "error_saving_settings": "Erro ao salvar",
  "error_sending": "Erro ao enviar",
  "error_uploading": "Erro ao carregar",
  "error_uploading_photo": "Falha ao carregar foto",
  "events_calendar": "Calendário de Eventos",
  "excerpt_summary": "Resumo / Sumário",
  "experimental": "Experimental",
  "export": "Exportar",
  "export_data": "Exportar Dados",
  "facebook": "Facebook",
  "facebook_login_unavailable": "Login do Facebook indisponível",
  "failed_post_comment": "Falha ao publicar comentário.",
  "feature_flags": "Flags de Recurso",
  "feature_job": "Emprego em Destaque",
  "featured": "Em destaque",
  "featured_article": "Artigo em Destaque",
  "featured_duration": "Duração em Destaque",
  "featured_image": "Imagem em Destaque",
  "featured_jobs": "Vagas em destaque",
  "feedback": "Feedback",
  "filter": "Filtrar",
  "filter_terms_saved": "Termos do filtro salvos!",
  "find_jobs": "Encontrar empregos",
  "first": "Primeiro",
  "first_process_publish": "Primeiro processe e publique o artigo",
  "footer_ai": "Este portal usa assistencia de IA",
  "footer_ai_notice": "Alguns conteúdos criados com assistência de IA - relatar problemas",
  "footer_cat_business": "Negócios",
  "footer_cat_culture": "Cultura",
  "footer_cat_health": "Saúde",
  "footer_cat_news": "Notícias",
  "footer_cat_politics": "Política",
  "footer_cat_sports": "Esportes",
  "footer_cat_technology": "Tecnologia",
  "footer_categories": "Categorias",
  "footer_copyright": "2026 Liber Nostra d.o.o. Todos os direitos reservados.",
  "footer_description": "Croatia Times é sua fonte confiável para notícias de última hora, análises aprofundadas e histórias envolventes da Croácia e além.",
  "footer_developed_by": "Desenvolvido e mantido com amor por",
  "footer_email_placeholder": "Seu endereço de email",
  "footer_here": "aqui",
  "footer_hosted_by": "Hospedado por",
  "footer_link_about": "Sobre Nós",
  "footer_link_advertise": "Anunciar",
  "footer_link_contact": "Contato",
  "footer_link_cookies": "Cookies",
  "footer_link_imprint": "Impressão",
  "footer_link_privacy": "Política de Privacidade",
  "footer_link_submit_news": "Enviar Notícias",
  "footer_newsletter_text": "Inscreva-se na nossa newsletter",
  "footer_quick_links": "Links rápidos",
  "footer_stay_informed": "Mantenha-se informado",
  "footer_subscribe": "Inscrever-se",
  "for_you_personalized": "Conteúdo personalizado com base em seus interesses",
  "for_you_title": "Para Você",
  "forgot_password": "Esqueceu a senha?",
  "free": "Grátis",
  "free_plan": "Gratis",
  "from": "De",
  "full_time": "Tempo integral",
  "general": "Geral",
  "goodbye": "Adeus",
  "hashtags": "Hashtags",
  "hashtags_placeholder": "#news #croatia...",
  "header_auto_schedule_active": "Agendamento automático ativo",
  "header_forecast": "Previsão",
  "header_humidity": "Umidade",
  "header_live": "AO VIVO",
  "header_portals_label": "Portais",
  "header_weather_humidity": "Umidade",
  "header_weather_wind": "Vento",
  "header_wind": "Vento",
  "health": "Saude",
  "hello": "Olá",
  "help": "Ajuda",
  "home": "Inicio",
  "home_podcast_title": "Resumo Semanal de Tecnologia: IA em Startups Croatas",
  "home_video_title": "Dentro de Zagreb: Documentário sobre Arte de Rua",
  "hours": "horas",
  "import": "Importar",
  "impressions": "Impressoes",
  "imprint": "Expediente",
  "imprint_title": "Impressão",
  "inactive": "Inativo",
  "info": "Informação",
  "instagram": "Instagram",
  "invalid_code": "Código inválido. Tente novamente.",
  "items_selected": "itens selecionados",
  "job_categories": "Categorias de emprego",
  "job_postings": "Vagas de Emprego",
  "job_seeker": "Candidato",
  "jobs": "Empregos",
  "just_now": "Agora mesmo",
  "language": "Idioma",
  "last": "Último",
  "latest_news": "Últimas Notícias",
  "legal": "Legal",
  "lifestyle": "Estilo de vida",
  "lifetime": "Vitalício",
  "light_mode": "Modo claro",
  "linked_email_campaign": "Vinculado à campanha de email",
  "linkedin": "LinkedIn",
  "live_stream": "Transmissão Ao Vivo",
  "load_more": "Carregar mais",
  "loading": "Carregando...",
  "local": "Local",
  "location": "Local",
  "login": "Entrar",
  "logout": "Sair",
  "loyalty_available_points": "Pontos Disponíveis",
  "loyalty_available_rewards": "Recompensas Disponíveis",
  "loyalty_badges": "Distintivos",
  "loyalty_consecutive_days": "Dias Consecutivos",
  "loyalty_error": "Erro",
  "loyalty_leaderboard": "Classificação",
  "loyalty_leaderboard_empty": "Classificação está vazia",
  "loyalty_rewards": "Recompensas",
  "loyalty_used_rewards": "Recompensas Usadas",
  "majstor_categories": "Categorias",
  "majstor_city": "Cidade",
  "majstor_company_name": "Nome da Empresa *",
  "majstor_flexible": "Flexível",
  "majstor_max_budget": "Orçamento máximo (EUR)",
  "majstor_min_budget": "Orçamento mínimo (EUR)",
  "majstor_my_requests": "Meus Pedidos",
  "majstor_request_title": "Título do Pedido *",
  "majstor_service_categories": "Categorias de Serviço",
  "majstor_urgent": "Urgente",
  "manage": "Gerenciar",
  "manage_bookings": "Gerenciar reservas de anunciantes",
  "mark_as_read": "Marcar como lido",
  "marketing_dashboard": "Painel de Marketing",
  "marketing_live_metrics": "Métricas de desempenho ao vivo para Croatia Times",
  "marketing_published_articles": "Artigos Publicados",
  "marketing_registered_users": "Usuários Registrados",
  "marketing_today_views": "Visualizações de Hoje",
  "marketing_total_views": "Total de Visualizações de Página",
  "minutes": "minutos",
  "missing_translations": "Traduções Faltantes",
  "mobile": "Celular",
  "more": "Mais",
  "most_popular": "Mais popular",
  "most_read": "Mais Lidos",
  "move": "Mover",
  "must_be_logged_in_purchase": "Você deve estar logado para comprar um artigo",
  "myProfile": "Meu Perfil",
  "my_applications": "Minhas candidaturas",
  "name": "Nome",
  "new": "Novo",
  "new_article": "Novo Artigo",
  "new_campaign": "Nova Campanha",
  "new_notification": "Nova Notificação",
  "new_push_notification": "Nova Notificação Push",
  "new_verification_sent": "Um novo código de verificação foi enviado para seu email.",
  "news": "Noticias",
  "newsletter": "Boletim",
  "newsletter_desc": "Inscreva-se para as ultimas noticias",
  "newsletter_only_subscribers": "Apenas assinantes",
  "newsletter_subscribers": "Assinantes da newsletter",
  "next": "Proximo",
  "no": "Não",
  "noAccount": "Não tem uma conta?",
  "no_articles": "Nenhum artigo encontrado",
  "no_bookings": "Nenhuma reserva encontrada",
  "no_campaigns": "Nenhuma campanha",
  "no_data": "Nenhum dado disponível",
  "no_items": "Nenhum item encontrado",
  "no_linked_campaign": "Nenhuma campanha vinculada",
  "no_notifications": "Sem notificações",
  "no_results": "Sem resultados",
  "no_scheduled_posts": "Ainda não há publicações agendadas",
  "no_sent_notifications": "Nenhuma notificação enviada",
  "none": "Nenhum",
  "note": "Nota",
  "notification_body": "Corpo da Notificação",
  "notification_title": "Título da Notificação",
  "notifications": "Notificações",
  "of": "de",
  "off": "Desligado",
  "offline": "Offline",
  "on": "Ligado",
  "one_time": "unico",
  "online": "Online",
  "open_rate": "Taxa de abertura",
  "optional": "Opcional",
  "options": "Opções",
  "orContinueWith": "Ou continue com",
  "or_continue_with": "Ou continue com",
  "order": "Pedido",
  "other": "Outros",
  "page": "Página",
  "part_time": "Meio periodo",
  "password": "Senha",
  "paste": "Colar",
  "pause": "Pausar",
  "payment_error": "Erro no pagamento",
  "payment_processing": "Processando pagamento...",
  "payment_success": "Pagamento bem-sucedido!",
  "payment_thank_you": "Obrigado pela sua compra!",
  "pending": "Pendente",
  "pending_approval": "Aguardando Aprovação",
  "per_month": "/mes",
  "per_page": "por página",
  "percentage": "Porcentagem",
  "performance": "Desempenho",
  "phone": "Telefone",
  "platforms": "Plataformas",
  "politics": "Politica",
  "poll_results": "Resultados",
  "poll_total_votes": "Total de Votos",
  "poll_vote": "Votar",
  "popular": "Popular",
  "post_comment": "Publicar comentário",
  "post_error": "Erro de postagem",
  "post_job": "Publicar vaga",
  "post_now": "Publicar Agora",
  "powered_by": "Desenvolvido por",
  "premium": "Premium",
  "preview": "Pré-visualizar",
  "previous": "Anterior",
  "price": "Preço",
  "privacy": "Privacidade",
  "privacy_title": "Política de Privacidade",
  "proceed_to_payment": "Proceder para Pagamento",
  "profile": "Perfil",
  "profile_admin_access": "Acesso Rápido do Admin",
  "profile_analytics": "Analítica",
  "profile_articles": "Artigos",
  "profile_dashboard": "Painel",
  "profile_edit": "Editar Perfil",
  "profile_verified": "Perfil verificado!",
  "promo_success": "Código promocional aplicado com sucesso!",
  "promote_job": "Promover Emprego",
  "publish": "Publicar",
  "published": "Publicado",
  "published_date": "Publicado",
  "push_notifications": "Notificações Push",
  "read": "Lido",
  "read_more": "Leia mais",
  "real_estate": "Imóveis",
  "recent": "Recentes",
  "recipes_add_first": "Adicione sua primeira receita",
  "recipes_browse_all": "Ver todas as receitas",
  "recipes_category": "Categoria",
  "recipes_cook_time": "Tempo de Cozimento",
  "recipes_easy": "Fácil",
  "recipes_featured": "Receitas em Destaque",
  "recipes_filters": "Filtros",
  "recipes_ingredient": "Ingrediente",
  "recipes_ingredients": "Ingredientes",
  "recipes_instructions": "Instruções",
  "recipes_latest": "Últimas Receitas",
  "recipes_most_popular": "Receitas Mais Populares",
  "recipes_prep_time": "Tempo de Preparo",
  "recipes_search": "Buscar receitas...",
  "recipes_servings": "Porções",
  "recipes_title": "Receitas",
  "recommended": "Recomendado",
  "refresh": "Atualizar",
  "region": "Região",
  "register": "Registrar",
  "reject": "Rejeitar",
  "rejected": "Rejeitado",
  "related_articles": "Artigos Relacionados",
  "remote": "Remoto",
  "remove": "Remover",
  "report": "Relatório",
  "reports": "Relatórios",
  "reposting_rules_title": "Regras de Republicação",
  "required": "Obrigatório",
  "reset": "Redefinir",
  "restore": "Restaurar",
  "results": "Resultados",
  "resume": "Retomar",
  "revision_restored": "Revisão restaurada!",
  "salary": "Salario",
  "salary_max": "Salário Máximo",
  "salary_min": "Salário Mín",
  "save": "Salvar",
  "saved_jobs": "Vagas salvas",
  "saved_successfully": "Salvo com sucesso",
  "schedule": "Agendar",
  "scheduled": "Agendado",
  "science": "Ciencia",
  "search": "Pesquisar...",
  "search_articles": "Pesquisar artigos...",
  "search_placeholder": "Pesquisar...",
  "search_results_for": "Resultados de busca para",
  "seconds": "segundos",
  "see_all": "Ver todos",
  "select": "Selecionar",
  "select_all": "Selecionar tudo",
  "select_format": "Selecionar Formato",
  "seller": "Vendedor",
  "send_campaign": "Enviar Campanha",
  "sent": "Enviado",
  "sent_campaigns": "Campanhas Enviadas",
  "services": "Serviços",
  "settings": "Configurações",
  "share": "Compartilhar",
  "showing": "Mostrando",
  "signIn": "Entrar",
  "signOut": "Sair",
  "site_name": "Croatia Times",
  "site_subtitle": "Croacia Hoje",
  "six_digit_code": "Código de 6 dígitos",
  "social_media": "Mídias Sociais",
  "social_scheduler": "Agendador Social",
  "sort": "Ordenar",
  "sponsored_marketplace_title": "Marketplace Patrocinado",
  "sports": "Esportes",
  "stable": "Estável",
  "start": "Iniciar",
  "start_date": "Data de Início",
  "static_about_contact": "Para perguntas editoriais, publicidade ou informações gerais, visite nossa",
  "static_about_contact_page": "página de contato",
  "static_about_contact_title": "Contato",
  "static_about_lead": "Croatia Times é um portal de notícias independente que traz as últimas notícias, análises, comentários e histórias da Croácia e da região. Fazemos parte da família de mídia e-mina.eu, com a mesma equipe e os mesmos valores.",
  "static_about_mission": "Estamos dedicados a oferecer jornalismo preciso, oportuno e de qualidade que sirva ao interesse público. Nossa equipe editorial é composta por jornalistas experientes com profundo conhecimento dos assuntos croatas e regionais.",
  "static_about_mission_title": "Nossa Missão",
  "static_about_publisher": "Liber Nostra d.o.o. é a editora do Croatia Times e do e-mina.eu. A empresa é especializada em mídia digital e portais de notícias focados no mercado croata.",
  "static_about_publisher_title": "Editora",
  "static_about_standards": "Croatia Times adere aos mais altos padrões jornalísticos. Verificamos os fatos em nossos relatórios, rotulamos claramente comentários e análises, e corrigimos erros de maneira transparente e rápida.",
  "static_about_standards_title": "Padrões Editoriais",
  "static_about_team": "Por trás do Croatia Times está uma equipe de profissionais de mídia experientes, jornalistas, editores e especialistas técnicos que trabalham no desenvolvimento da plataforma e na qualidade do conteúdo. Nossa equipe é a mesma por trás do bem-sucedido portal e-mina.eu - International News Agency.",
  "static_about_team_title": "Equipe",
  "static_about_title": "Sobre Nós - Croatia Times",
  "static_bug_description": "Descrição do Bug",
  "static_bug_description_placeholder": "Descreva o que aconteceu e como reproduzir o problema...",
  "static_bug_intro": "Encontrou algo que não está funcionando corretamente? Informe-nos e nós o corrigiremos prontamente.",
  "static_bug_page_url": "URL da página (onde ocorreu o bug)",
  "static_bug_screenshot": "Captura de tela (opcional)",
  "static_bug_submit": "Enviar Relatório de Bug",
  "static_bug_submitting": "Enviando...",
  "static_bug_thanks": "Obrigado pelo seu relatório! Iremos investigar e corrigir o problema.",
  "static_bug_title": "Reportar um Bug",
  "static_commenting_intro": "Acolhemos discussões construtivas. Para manter nossa seção de comentários positiva e produtiva, siga estas regras:",
  "static_commenting_login": "Para comentar, você deve estar registrado e logado no Croatia Times.",
  "static_commenting_rule_1": "Seja respeitoso e civilizado com outros usuários e assuntos dos artigos",
  "static_commenting_rule_2": "Proibido discurso de ódio, racismo, sexismo ou discriminação de qualquer tipo",
  "static_commenting_rule_3": "Proibido spam, publicidade ou conteúdo promocional",
  "static_commenting_rule_4": "Proibido disseminar informações falsas ou declarações não verificadas",
  "static_commenting_rule_5": "Proibido ataques pessoais ou assédio",
  "static_commenting_rule_6": "Mantenha-se no tema e contribua para a conversa",
  "static_commenting_rule_7": "Proibido compartilhar informações pessoais ou confidenciais de terceiros",
  "static_commenting_title": "Regras de Comentários",
  "static_commenting_violation": "Comentários que violam estas regras podem ser removidos sem aviso. Infratores recorrentes podem ser permanentemente banidos.",
  "static_contact_email": "Email",
  "static_contact_message": "Mensagem",
  "static_contact_message_placeholder": "Sua mensagem...",
  "static_contact_name": "Nome",
  "static_contact_name_placeholder": "Seu nome",
  "static_contact_send": "Enviar Mensagem",
  "static_contact_sending": "Enviando...",
  "static_contact_sent_desc": "Entraremos em contato com você dentro de 24 horas.",
  "static_contact_sent_title": "Mensagem Enviada!",
  "static_contact_subject": "Assunto",
  "static_contact_subject_placeholder": "Como podemos ajudar?",
  "static_contact_title": "Contate-Nos",
  "static_cookies_advertising_text": "Podemos usar cookies do Google AdSense para exibir anúncios relevantes.",
  "static_cookies_advertising_title": "Cookies de Publicidade",
  "static_cookies_analytics_text": "O Google Analytics nos ajuda a entender como os visitantes usam nosso site. Os dados são anonimizados sempre que possível.",
  "static_cookies_analytics_title": "Cookies de Análise",
  "static_cookies_managing_text": "Você pode controlar os cookies através das configurações do seu navegador. Desativar cookies necessários pode afetar a funcionalidade do site.",
  "static_cookies_managing_title": "Gerenciamento de Cookies",
  "static_cookies_necessary_text": "Estes são necessários para o funcionamento do site (sessões de login, preferências de tema). Eles não podem ser desativados.",
  "static_cookies_necessary_title": "Cookies Necessários",
  "static_cookies_title": "Política de Cookies",
  "static_cookies_types_title": "Tipos de Cookies que Usamos",
  "static_cookies_what_text": "Cookies são pequenos arquivos de texto colocados no seu dispositivo quando você visita um site. Eles ajudam o site a lembrar suas preferências e entender como você o utiliza.",
  "static_cookies_what_title": "O Que São Cookies",
  "static_imprint_ads_email": "Email (publicidade):",
  "static_imprint_ai_notice": "Alguns conteúdos são gerados usando tecnologia de IA. Relate erros ou conteúdos inadequados para",
  "static_imprint_contact": "Contato",
  "static_imprint_copyright": "Direitos Autorais",
  "static_imprint_copyright_text": "Todo o conteúdo publicado no Croatia Times é protegido por direitos autorais. A Liber Nostra d.o.o. retém todos os direitos sobre textos, imagens e conteúdos multimídia publicados neste site. Informações detalhadas sobre as regras de repostagem de conteúdos estão disponíveis na",
  "static_imprint_ct_desc": "Portal de notícias Croatia Times",
  "static_imprint_disclaimer": "Aviso Legal",
  "static_imprint_disclaimer_text": "Apesar do cuidadoso controle de conteúdo, não assumimos responsabilidade por links externos. Seus operadores são os únicos responsáveis por seu conteúdo.",
  "static_imprint_editorial_email": "Email (editorial):",
  "static_imprint_emina_desc": "Agência Internacional de Notícias",
  "static_imprint_general_email": "Email (consultas gerais):",
  "static_imprint_last_updated": "Última atualização: fevereiro de 2026",
  "static_imprint_or_via": "ou via nosso",
  "static_imprint_publisher": "Editora",
  "static_imprint_registered": "Registrado na República da Croácia",
  "static_imprint_reposting_page": "página de Regras de Repostagem",
  "static_imprint_responsible": "Responsável pelo Conteúdo",
  "static_imprint_responsible_text": "Equipe editorial do Croatia Times / Liber Nostra d.o.o.",
  "static_imprint_title": "Impressão",
  "static_imprint_websites": "Websites",
  "static_privacy_controller": "Controlador de Dados: Liber Nostra d.o.o.",
  "static_privacy_cookies_text": "Usamos cookies para funcionalidade e análise. Veja nossa Política de Cookies para mais detalhes.",
  "static_privacy_cookies_title": "Cookies",
  "static_privacy_data_text": "Coletamos dados que você fornece diretamente (nome, email ao se inscrever), dados de uso (páginas visitadas, artigos lidos) e dados técnicos (endereço IP, tipo de navegador).",
  "static_privacy_data_title": "Dados que Coletamos",
  "static_privacy_last_updated": "Última atualização: Janeiro de 2026",
  "static_privacy_lead": "Croatia Times respeita sua privacidade e está comprometida com a proteção de seus dados pessoais.",
  "static_privacy_retention_text": "Reteremos seus dados enquanto sua conta estiver ativa ou conforme necessário para fins legais.",
  "static_privacy_retention_title": "Retenção de Dados",
  "static_privacy_rights_text": "Você tem o direito de acessar, corrigir ou deletar seus dados pessoais. Entre em contato conosco em",
  "static_privacy_rights_title": "Seus Direitos",
  "static_privacy_title": "Política de Privacidade",
  "static_privacy_usage_text": "Usamos seus dados para fornecer nosso serviço de notícias, personalizar sua experiência, enviar newsletters (com seu consentimento) e melhorar nossa plataforma.",
  "static_privacy_usage_title": "Como Usamos Seus Dados",
  "static_reposting_copyright_text": "Todo o conteúdo publicado no Croatia Times é protegido por direitos autorais. Liber Nostra d.o.o. detém todos os direitos sobre o texto, imagens e multimídia publicados neste site.",
  "static_reposting_copyright_title": "Direitos Autorais",
  "static_reposting_permission_text": "Para permissão para reproduzir conteúdo, entre em contato conosco em",
  "static_reposting_permission_title": "Solicitações de Permissão",
  "static_reposting_permitted_text": "Você pode compartilhar links para nossos artigos em redes sociais e outras plataformas. Citações curtas (até 2 parágrafos) podem ser usadas com atribuição clara e um link de volta para o artigo original.",
  "static_reposting_permitted_title": "Uso Permitido",
  "static_reposting_prohibited_text": "Proibida a reprodução completa de artigos sem permissão por escrito. Imagens não podem ser reproduzidas sem permissão. Raspagem automatizada de conteúdo é estritamente proibida.",
  "static_reposting_prohibited_title": "Uso Proibido",
  "static_reposting_title": "Regras de Repostagem",
  "static_submit_news_details": "Detalhes da História",
  "static_submit_news_details_placeholder": "Descreva a notícia...",
  "static_submit_news_file_limit_error": "O arquivo excede o limite de",
  "static_submit_news_headline": "Título da Notícia",
  "static_submit_news_intro": "Tem notícias? Envie aqui e nossa equipe editorial irá revisá-las.",
  "static_submit_news_limit": "Aceitamos fotos e vídeos de até",
  "static_submit_news_photos": "Fotos / Vídeo (até",
  "static_submit_news_send": "Enviar Notícias",
  "static_submit_news_sending": "Enviando...",
  "static_submit_news_source": "Fonte / Referência (opcional)",
  "static_submit_news_source_placeholder": "URL ou referência",
  "static_submit_news_thanks": "Obrigado por sua submissão! Nossa equipe irá analisá-la em breve.",
  "static_submit_news_title": "Envie Suas Notícias",
  "static_submit_news_your_name": "Seu Nome",
  "status": "Status",
  "stop": "Parar",
  "submit": "Enviar",
  "submitNews": "Enviar Notícias",
  "submit_bug_title": "Enviar Relatório de Bug",
  "submit_news": "Enviar noticia",
  "submit_news_title": "Enviar Notícias",
  "subscribe": "Inscrever-se",
  "subscription": "Assinatura",
  "subscription_title": "Planos de Assinatura",
  "success": "Sucesso",
  "support": "Suporte",
  "tablet": "Tablet",
  "tags": "Tags",
  "target_impressions": "Impressões Alvo",
  "technology": "Tecnologia",
  "template": "Modelo",
  "templates": "Modelos",
  "terms": "Termos",
  "thank_you": "Obrigado",
  "this_month": "Este mês",
  "this_week": "Esta semana",
  "this_year": "Este ano",
  "tip": "Dica",
  "title": "Título",
  "to": "Para",
  "today": "Hoje",
  "total": "Total",
  "translate_all": "Traduzir Tudo",
  "translation_status": "Status da Tradução",
  "translations": "Traduções",
  "travel": "Viagem",
  "trending": "Em Alta",
  "try_again": "Tentar novamente",
  "twitter": "Twitter",
  "two_factor_auth": "Autenticação de Dois Fatores",
  "type": "Tipo",
  "ugc_submit": "Enviar Conteúdo",
  "ugc_title": "Portal de Jornalismo Cidadão",
  "unique_clicks": "Cliques Únicos",
  "unique_opens": "Aberturas Únicas",
  "unknown": "Desconhecido",
  "unpublish": "Despublicar",
  "unread": "Não lido",
  "update": "Atualizar",
  "updated_successfully": "Atualizado com sucesso",
  "upgrade": "Melhorar",
  "upload": "Enviar",
  "users": "Usuários",
  "vehicles": "Veículos",
  "verification_code_sent": "Código de verificação enviado para seu email!",
  "version": "Versão",
  "vibeposao": "Times Posao",
  "view": "Visualizar",
  "view_all": "Ver todos",
  "views": "Visualizacoes",
  "warning": "Aviso",
  "welcome": "Bem-vindo",
  "wish_roles": "Cargos desejados",
  "working_hours_saved": "Horário de trabalho salvo!",
  "world": "Mundo",
  "write_new_article": "Escrever Novo Artigo",
  "yes": "Sim",
  "yesterday": "Ontem",
  "your_bookings": "Suas Reservas",
  "youtube": "YouTube"
}
